import { Component, OnDestroy, OnInit, forwardRef, DoCheck, ChangeDetectorRef, Inject, OnChanges, SimpleChanges, Input, inject } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '@infrastructure/ValidationMessages/ExternalValidationDirective';
//import { WorkflowComponent } from '../../../../workflow.component';
//import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
//import { DomainCodes } from '../../../../../../models/const.DomainCodes';
//import { HttpClient } from '@angular/common/http';
//import { ActivatedRoute } from '@angular/router';
import { ModalService } from '@infrastructure/Modal/ModalService';
//import { confirmRemoveFromList } from '@infrastructure/TableEdit/TableEditBase';
//import { isUndefined, isNullOrUndefined } from '@infrastructure/objectUtils';
import { BeneficiaryListTableEditComponent } from '../../beneficiary-list-table-edit.component';
//import { TableEditBase } from '@infrastructure/TableEdit/TableEditBase';
//import { BenefitChoosen } from '@infrastructure/Documents/benefit-choosen.enum';


@Component({
  selector: 'person-type',
  templateUrl: './person-type.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => BeneficiaryListTableEditComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],

  standalone: false
 
})

export class PersonTypeComponent  implements OnInit, OnDestroy{

  @Input("yesNo")
  public yesNo: models.DimensionVM[];

  //@Input() benefitChoosen: BenefitChoosen;

  //public BenefitChoosen = BenefitChoosen;

  @Input("cardData")
  public cardData: models.PersonTypeVM;
  //@Input("cardDataBeneficiaryIdentification")
  //public cardDataBeneficiaryIdentification: models.BeneficiaryIdentificationVM;

  @Input("dropdowns")
  public dropdowns: models.WorkflowDropdownsVM ;

  public dropDownPersonTypes: models.Options[] = [];
  
  controlContainer: ControlContainer;
  constructor(@Inject(BeneficiaryListTableEditComponent) public parent: Component, private modalService: ModalService) {
    this.controlContainer = inject(ControlContainer);
  }




  ngOnInit(): void {
    if (!!this.dropdowns) {
      this.dropDownPersonTypes = this.dropdowns.options
        .filter(el => el.dropdown === "dropDownPersonType");
    }
  }

  ngOnDestroy(): void {
  }

  personTypelogyCodeChanged(option: models.Options) {
    this.cardData.personTypology = option.description;
  }
}
